import { Events, addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import { SESSION_STORAGE_KEYS } from '../../../gatsby/constants';
import { IProductPage } from '../../types/product/productDetailPage';

interface EventLabel {
  name: string;
  contentfulId: string;
}
interface DataLayerProductInformation {
  id?: string;
  productPageProductName?: string;
  variantSKU?: string;
  eventLabel: EventLabel
}
interface EventCustomData {
  eventAction: string;
  eventValue?: string;
  customEventLabel?: object;
  eventNonInteraction?: boolean;
}

/**
 * @param {Object} productInformation
 * @param {Object} eventCustomData
 * @return {*}
 */
export const dispatchDataLayerEvent = ({
  id, eventLabel, productPageProductName, variantSKU,
}: DataLayerProductInformation, {
  eventAction, customEventLabel, eventValue, eventNonInteraction,
}: EventCustomData) => {
  const eventLabelVal = { ...eventLabel, ...customEventLabel };
  // GA3
  addDataLayerEntry('gaEventEec', {
    gaEvent: {
      eventCategory: 'ecommerce',
      eventAction,
      eventLabel: JSON.stringify({
        eventLabelVal,
      }),
      eventValue,
      eventNonInteraction,
    },
    ecommerce: {
      detail: {
        actionField: {
          list: sessionStorage[SESSION_STORAGE_KEYS.LIST_NAME] ?? '',
          position: sessionStorage[SESSION_STORAGE_KEYS.POSITION] ?? '',
        },
        products: [{
          id,
          name: eventLabel.name,
          dimension39: productPageProductName,
          // @ts-expect-error
          [process.env.GATSBY_DATALAYER_FIELD_CONTENTFUL_ID]: eventLabel.contentfulId,
          // @ts-expect-error
          [process.env.GATSBY_DATALAYER_FIELD_VARIANTSKU]: variantSKU,
        }],
      },
    },
  });

  // GA4
  addDataLayerEntry('view_item', {
    ecommerce: {
      items: [{
        item_id: id,
        item_name: eventLabel.name,
        currency: 'EUR',
        value: 1, // TODO: this is hardcoded for now but somehow we need a base price in future
      }],
    },
  });
};

export const dispatchDataLayerEntry = (
  eventName: string,
  actionName: string,
  changes?: { [key: string]: any },
  GA4EventName?: string,
) => {
  // GA4
  const GA4Event = GA4EventName || (['click', 'display'].includes(actionName) ? `${eventName}_${actionName}` : actionName);
  addDataLayerEntry(GA4Event, {
    ...changes,
  });

  // GA3
  addEventEntry({
    eventCategory: eventName,
    eventAction: actionName,
    eventLabel: JSON.stringify(changes),
  });
};

export const handleRecommendationProductImpressions = (
  listName: string,
  products: IProductPage[],
  analyticsId: string,
  placementId?: string,
  placementName?: string,
) => {
  addDataLayerEntry(
    'view_item_list',
    {
      item_list_id: analyticsId,
      item_list_name: listName,
      ...(placementId && { recommendation_id: placementId }),
      ...(placementName && { recommendation_name: placementName }),
      items: products.map((product: IProductPage, i) => (
        {
          index: i + 1,
          item_id: product.id,
          item_name: product.productName,
          item_category: product.productCategory?.categoryName,
          item_list_name: listName,
          item_list_id: analyticsId,
          contentful_id: product.contentful_id,
          category: product.productCategory?.categoryName,
        }
      )),
      eventNonInteraction: true,
    },
  );
};

export const dispatchFileCheckDataLayerEvent = (serviceKeys: string[] | string | undefined) => {
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory: 'product_detail_page',
      eventAction: serviceKeys && serviceKeys.length > 0 ? 'file_check_selected' : 'file_check_not_selected',
      eventNonInteraction: false,
    },
  });
};
